module.exports = __webpack_public_path__ + "media/images/browsers/netscape-589869c174868607a35990b62e899884.svg";